module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/tag/details-c929ed.png";